const emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/);

export const isValidEmail = (email) => {
    return Boolean(email.match(emailRegex));
};
